import { TagInitialization } from 'src/components/oneCorp/features/MealCredit/hooks/useAssignAllowanceAmount';

export enum MealCreditAnalyticsEvent {
  ASSIGN_GROUP = 'assign group to meal credit_cta',
  UPDATE_GROUP = 'update group_cta',
}

export function getMealCreditGroupAnalyticsEvent(
  isAdding: boolean,
  isUpdating: boolean
): string | null {
  if (isAdding) {
    return MealCreditAnalyticsEvent.ASSIGN_GROUP;
  }
  if (isUpdating) {
    return MealCreditAnalyticsEvent.UPDATE_GROUP;
  }
  return null;
}

export function getMealCreditAllowanceAnalyticsEvent(
  tagInitializationStatus: TagInitialization
): string | null {
  switch (tagInitializationStatus) {
    case TagInitialization.NOT_INITIALIZED:
      return MealCreditAnalyticsEvent.ASSIGN_GROUP;
    case TagInitialization.INITIALIZED:
      return MealCreditAnalyticsEvent.UPDATE_GROUP;
    default:
      return null;
  }
}
